export const ACCEPTED_BANNER_IMG_FORMATS = '.jpg,.jpeg,.png'
export const ACCEPTED_BANNER_IMG_FORMATS_HUMAN = '.jpg, .jpeg, .png'
export const FILE_SIZE_2MB = 2 * 1024 * 1024
export const FILE_SIZE_2MB_HUMAN = '2MB'
export const MAX_PARTICIPANT_SPOTS = 100000
